import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const quickTestimonials = [{
  name: 'María José',
  location: 'Buenos Aires',
  initials: 'MJ',
  color: 'bg-maternal-amber',
  quote: 'Al día 7, tuvimos una charla de 20 minutos. Lloré de alegría.'
}, {
  name: 'Carolina',
  location: 'Córdoba',
  initials: 'C',
  color: 'bg-maternal-orange',
  quote: 'Ahora mi hijo me busca para contarme cosas del colegio.'
}];
export function QuickTestimonials() {
  return <section className="py-6 md:py-10 bg-maternal-cream" data-id="element-223">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-224">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-225">
          {quickTestimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-4 md:p-5 rounded-xl shadow-sm border border-maternal-beige flex items-start gap-3" data-id="element-226">
              <div className={`w-10 h-10 rounded-full ${t.color} text-white flex items-center justify-center font-bold text-sm flex-shrink-0`} data-id="element-227">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-228">
                <div className="flex items-center gap-2 mb-1" data-id="element-229">
                  <span className="font-bold text-sm text-maternal-brown" data-id="element-230">
                    {t.name}
                  </span>
                  <span className="text-xs text-maternal-lightBrown/60" data-id="element-231">
                    · {t.location}
                  </span>
                  <div className="flex ml-auto" data-id="element-232">
                    {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-3 h-3 text-maternal-amber fill-current" data-id="element-233" />)}
                  </div>
                </div>
                <p className="text-sm text-maternal-lightBrown italic leading-snug" data-id="element-234">
                  "{t.quote}"
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}